import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { ErrorScreen } from '../ErrorScreen';
import { useRouting } from '../../shared/use-routing';
import { useDocumentTitle } from '../../shared/use-document-title';
import { pagePathnames } from '../../pages/page-routes';
import { logError } from '../../../lib/shared/error-logger';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';

function AppErrorBoundary() {
    const error = useRouteError();
    const { buildPath } = useRouting();

    useDocumentTitle('Something went wrong');

    useEffect(() => {
        logError(error);
        logEvent(EVENT_TYPES.APP_ERROR_VIEWED);
    }, [error]);

    return (
        <ErrorScreen
            fallbackPath={buildPath(pagePathnames.dashboard)}
            fallbackLabel='Back to dashboard'
        />
    );
}

export {
    AppErrorBoundary
};
